import { __awaiter, __generator } from "tslib";
import { fetchOfficeComponentContext, useOfficeComponentContext, } from '@office-start/component-context-service';
import { useMemo } from 'react';
export function useAIHubEnabled(rootPath) {
    var componentContext = useOfficeComponentContext().data;
    var path = rootPath || (componentContext === null || componentContext === void 0 ? void 0 : componentContext.rootPath);
    return useMemo(function () { return isAIHubEnabled(path); }, [path]);
}
export function fetchAIHubEnabled() {
    return __awaiter(this, void 0, void 0, function () {
        var context;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchOfficeComponentContext()];
                case 1:
                    context = _a.sent();
                    return [2 /*return*/, isAIHubEnabled(context === null || context === void 0 ? void 0 : context.rootPath)];
            }
        });
    });
}
function isAIHubEnabled(rootPath) {
    return rootPath === '/v3' || rootPath === '/v3/apphosted';
}
export function isPrepareNativeModuleEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubPrepareModuleNativeIntegrationEnabled);
}
export function isWorkplaceModuleEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubWorkplaceModuleEnabled);
}
export function isActionsEnabledForV2(featureGates, userEntitlements) {
    var _a, _b;
    var hasCopilotBusinessChat = ((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubWebScopeCheck)
        ? true
        : userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.HasCopilotBusinessChat;
    var actionsV2Enabled = !!((_b = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _b === void 0 ? void 0 : _b.aiHubAutomateModuleEnabledForV2);
    return actionsV2Enabled && hasCopilotBusinessChat;
}
export function isCreateNativeEnabled(featureGates) {
    var _a;
    // NOTE: This is checking if MOS is enabled. We want to show the native module by default.
    return !((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubCreateModuleMOSIntegrationEnabled);
}
export function isAssistModuleEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubAssistModuleEnabled);
}
export function isActionsModuleEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubAutomateModuleEnabled);
}
export function isBizChatNativeEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubBizChatNativeEnabled);
}
export function isBrowseModuleEnabled(featureGates) {
    var _a, _b;
    return (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubBrowseModuleEnabled) !== null && _b !== void 0 ? _b : true;
}
export function isCatchUpModuleEnabled(featureGates) {
    var _a, _b;
    return (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubCatchUpModuleEnabled) !== null && _b !== void 0 ? _b : true;
}
export function isCreateModuleEnabled(featureGates) {
    var _a, _b;
    return (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubCreateModuleEnabled) !== null && _b !== void 0 ? _b : true;
}
export function isNewsModuleEnabled(featureGates) {
    var _a, _b;
    return (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubNewsModuleEnabled) !== null && _b !== void 0 ? _b : true;
}
export function isPrepareModuleEnabled(featureGates) {
    var _a, _b;
    return (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubPrepareModuleEnabled) !== null && _b !== void 0 ? _b : true;
}
export function isPeopleModuleEnabled(featureGates) {
    var _a, _b;
    return (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubPeopleModuleEnabled) !== null && _b !== void 0 ? _b : true;
}
export function isSharedDocumentCardsEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubSharedComponentDocumentCardsEnabled);
}
export function isSharedComponentPeopleCardsEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubSharedComponentPeopleCardsEnabled);
}
export function isSharedComponentMeetingCardsEnabled(featureGates) {
    var _a;
    return !!((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubSharedComponentMeetingCardsEnabled);
}
export function isCollectModuleEnabled(featureGates, userEntitlements, adminPolicy) {
    var _a;
    var hasLoopLicense = (adminPolicy === null || adminPolicy === void 0 ? void 0 : adminPolicy.LoopBizChatDocs) === 'Enabled' ? true : false;
    var hasCopilotBusinessChat = ((_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubWebScopeCheck)
        ? true
        : userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.HasCopilotBusinessChat;
    var hasSharepointLicense = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.HasSharePoint;
    // temporary fix, if Admin Policy is undefined, ignore check to default true.
    if (!adminPolicy) {
        return hasCopilotBusinessChat && hasSharepointLicense;
    }
    return hasLoopLicense && hasCopilotBusinessChat && hasSharepointLicense;
}
export function isCollectEnabledForV3(featureGates) {
    var _a, _b;
    return (_b = (_a = featureGates === null || featureGates === void 0 ? void 0 : featureGates.aiHubGates) === null || _a === void 0 ? void 0 : _a.aiHubCollectModuleEnabled) !== null && _b !== void 0 ? _b : true;
}
//# sourceMappingURL=useAIHubEnabled.js.map